export enum LookingFor {
  all = '0',
  men = '1',
  women = '2',
}
